/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import foodIcon from '../assets/shapes/food-icon.png'
import chidernIcon from '../assets/shapes/childern-icon.png'
import orphanIcon from '../assets/shapes/orphan-icon.png'
export const Features = () => {
  return (
    <div className="why Whome-container">
      <div className="why__content flex md:flex-row flex-col items-center lg:gap-16 md:gap-[32px] gap-[16px]">
        <div className=" lg:w-[40%] md:w-1/2 w-full">
          <h4 className="text-primary-green font-semibold text-lg">Our Mission</h4>
          <h1 className="text-3xl leading-[42px] md:text-[38px] md:leading-[55px] text-justify font-bold font-roboto">Together, We Can Make a Difference</h1>
          <p className="text-base font-normal text-justify font-roboto">
          Our commitment sets us apart as we carefully verify every cause and ensure that support reaches those who truly need it with compassion, transparency, and impact at the heart of everything we do.
          </p>
        </div>
        <div className="why__left lg:w-[60%] md:w-1/2 w-full flex flex-col gap-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 justify-center sm:gap-6 gap-4">
          <div className="why__item">
            <span className="bg-[#EDF7F5] p-[10px] rounded-full w-max ">
            <img src={foodIcon} alt="image" className="w-7 h-7" />
            </span>
            <h3 className="why__subheading">KWF PROVIDE FOOD</h3>
            <div className=" text-justify">
              KWF took upon itself this responsibility for providing free cooked
              meals to more than 5,000 indigent citizens of Pakistan.
            </div>
          </div>
          <div className="why__item">
          <span className="bg-[#EDF7F5] p-[10px] rounded-full w-max ">
            <img src={orphanIcon} alt="image" className="w-7 h-7" />
            </span>
            <h3
              className="why__subheading"
            >
              KWF ORPHANAGE
            </h3>
            <div className=" text-justify text-gray">
              To help children in distress who are orphaned, are taken care and
              provided with all the necessities for their upbringing.
            </div>
          </div>
          </div>
          <div className="why__item">
          <span className="bg-[#EDF7F5] p-[10px] rounded-full w-max ">
            <img src={chidernIcon} alt="image" className="w-7 h-7" />
            </span>
            <h3
              className="why__subheading"
            >
              KWF HELP SPECIAL CHILDREN
            </h3>
            <div className=" text-justify text-gray">
              Special children are looked after and taken with utmost care for
              their special needs. The poor, needy and handicapped are provided
              free-of-cost wheel chairs, crutches, artificial limbs, prosthesis,
              etc.
            </div>
          </div>
        </div>
       
      </div>
    </div>
  );
};
